import { gql } from "graphql-tag"

const typeAnniversaries = gql`
  type Anniversary {
    customerId: ID
    customerNumber: String
    name: String
    date: String
    type: String
  }

  type Anniversaries {
    items: [Anniversary]
  }

  type Query {
    allAnniversaries: Anniversaries
    anniversary: Anniversary
    customerAnniversaries(customerId: ID!): Anniversaries
  }
`

export { typeAnniversaries }

export default typeAnniversaries
